import { LoaderTraceLogo } from '@stratumn/atomic';

import graphql from 'babel-plugin-relay/macro';
import { ROUTE_ORG } from 'constant/routes';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import { QueryRenderer } from 'react-relay';
import { Redirect, withRouter } from 'react-router-dom';
import { toast } from 'sonner';
import { withGqlClient, withSpecificError, withUser } from 'wrappers';

import EditBotProfile from './editBotProfile';

const query = graphql`
  query editBotProfileQuery($botRowId: BigInt!) {
    botByRowId(rowId: $botRowId) {
      ...editBotProfile_bot
    }
  }
`;

export const Renderer = withSpecificError(
  ({ error, props: data, match: { params } }) => {
    if (!(data || error)) return <LoaderTraceLogo />;

    let bot;

    if (data) bot = data.botByRowId;

    if (error || !bot) {
      toast.error(`the bot with the id ${params.id} does not exist.`);
      return <Redirect to={ROUTE_ORG} />;
    }

    return <EditBotProfile bot={bot} />;
  }
);

Renderer.propTypes = {
  error: PropType.object,
  props: PropType.object
};

Renderer.defaultProps = {
  error: undefined,
  props: undefined
};

export const EditBotProfileRoot = props => {
  const { environment, botRowId } = props;

  const variables = {};
  variables.botRowId = botRowId;

  // We need to make sure that the location props are passed to child components correctly.
  // https://github.com/ReactTraining/react-router/blob/v4.2.2/packages/react-router/docs/guides/blocked-updates.md
  const RendererWithRouter = withRouter(Renderer);

  return (
    <QueryRenderer
      environment={environment}
      query={query}
      render={RendererWithRouter}
      variables={variables}
    />
  );
};

EditBotProfileRoot.propTypes = {
  environment: PropType.object.isRequired,
  botRowId: PropType.string.isRequired
};

EditBotProfileRoot.defaultProps = {};

export default compose(withUser, withGqlClient)(EditBotProfileRoot);
